import React from "react";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import "./App.css";
import Dashboard from "./pages/Dashboard/Dashboard";
import Vehicles from "./pages/Vehicles/Vehicles";
import VehicleDetail from "./pages/VehicleDetail/VehicleDetail";
import Flights from "./pages/Flights/Flights";
import Nexus from "./pages/Nexus/Nexus";
import AuthCallback from "./components/AuthCallback/AuthCallback";
import TractorStateRoute from "./pages/TractorState/TractorStateRoute";
import TractorMetricsRoute from "./pages/TractorMetrics/TractorMetricsRoute";
import RequireAuth from "./components/RequireAuth/RequireAuth";
import RequirePermission from "./components/RequirePermission/RequirePermission";

const App = () => {
  return (
    <Router>
      <Routes>
        <Route
          path="/"
          element={
            <RequireAuth>
              <Dashboard />
            </RequireAuth>
          }
        />

        <Route
          path="/dashboard"
          element={
            <RequireAuth>
              <Dashboard />
            </RequireAuth>
          }
        />

        <Route
          path="/vehicles"
          element={
            <RequireAuth>
              <Vehicles />
            </RequireAuth>
          }
        />

        <Route
          path="/vehicles/:vehicleName"
          element={
            <RequireAuth>
              <VehicleDetail />
            </RequireAuth>
          }
        />

        <Route
          path="/flights"
          element={
            <RequireAuth>
              <RequirePermission permission="read:aerovect-vehicles">
                <Flights />
              </RequirePermission>
            </RequireAuth>
          }
        />

        <Route
          path="/nexus"
          element={
            <RequireAuth>
              <RequirePermission permission="read:aerovect-vehicles">
                <Nexus />
              </RequirePermission>
            </RequireAuth>
          }
        />

        {/* The Cognito hosted UI's redirect target. Outside RequireAuth: there
            is no session yet when the browser arrives here, and wrapping it
            would start a second login on top of the one completing. */}
        <Route path="/callback" element={<AuthCallback />} />

        <Route path="/tractor-state/*" element={<TractorStateRoute />} />
        {/* Tractor Metrics (SW-8773): the activity timelines. Same session
            rules as Tractor State; see TractorMetricsRoute. */}
        <Route path="/metrics" element={<TractorMetricsRoute />} />
      </Routes>
    </Router>
  );
};

export default App;
